import { createLoaderImp } from '../../../../../components/ozmoit/common';
import { getStudentObservationsAction } from '../actions';

const {
  useLoaderData: StudentObservationsLoaderData,
  useLoader: StudentObservationsDataLoader, //Query search
  LoaderProvider,
} = createLoaderImp({
  action: getStudentObservationsAction,
});

function StudentObservationsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  StudentObservationsLoader,
  StudentObservationsDataLoader,
  StudentObservationsLoaderData,
};
